import React from "react";
import DataTable from "../../DataGrid/DataGrid";
import { GridColDef } from "@mui/x-data-grid";

interface TableProps {
  rows: any[];
  columns: GridColDef[];
  loading: boolean;
  page: number;
  pageSize: number;
  rowCount: number;
  pageChange: (index: number) => void;
  pageSizeChange: (size: number) => void;
}
const DocumentManagementTable: React.FC<TableProps> = ({
  rows,
  columns,
  loading,
  page,
  pageSize,
  pageChange,
  pageSizeChange,
  rowCount,
}) => {
  return (
    <div className="flex-1">
      <DataTable
        rows={rows}
        columns={columns}
        loading={loading}
        tableInfo={{
          id: `document-management`,
          label: `Document Management`,
          requireAuthSign: false,
          timestamp: { startTs: null, endTs: null },
        }}
        pageIndex={page}
        pageChange={pageChange}
        pageSize={pageSize}
        pageSizeChange={pageSizeChange}
        rowCount={rowCount}
        paginationMode="server"
      />
    </div>
  );
};

export default DocumentManagementTable;
